import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconPhoneComponent } from "./med-icon-phone.component";

@NgModule({
  declarations: [
    MedIconPhoneComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconPhoneComponent,
  ],
})
export class MedIconPhoneModule { }
